<template>
	<div class="product-detail-container">		
        <!-- 产品图片 -->
        <div class="product-image-section">
            <van-image
                class="product-image"
                :src="orderList.ImageURL"
                fit="cover"
            />
        </div>

        <!-- 产品信息卡片 -->
        <div class="info-card">
            <!-- 基本信息 -->
            <div class="info-section">
                <h3 class="section-title">产品信息</h3>
                <div class="info-list">
                    <div class="info-item">
                        <span class="info-label">产品名称</span>
                        <span class="info-value name-value">{{ orderList.ProductName }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">产品型号</span>
                        <span class="info-value">{{ orderList.Model }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">产品编码</span>
                        <span class="info-value">{{ orderList.ProductCode }}</span>
                    </div>
                </div>
            </div>

            <!-- 产品介绍 -->
            <div class="intro-section">
                <h3 class="section-title">产品介绍</h3>
                <div class="intro-content">
                    {{ orderList.Introduction }}
                </div>
            </div>

            <!-- 价格信息 -->
            <div class="price-section">
                <h3 class="section-title">价格信息</h3>
                <div class="price-content">
                    <span class="price-label">用户价格</span>
                    <span class="price-value">¥{{ orderList.UserPrice }}</span>
                </div>
            </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-section">
            <van-button type="primary" size="large" class="back-btn" to="/oow">
                <van-icon name="arrow-left" class="btn-icon" />
                返回列表
            </van-button>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {Dialog} from 'vant'	
	
	export default {
	  name: 'OOWINFO',	 
	  data(){
	  	return{					
			orderList:[]
		}
	  },
	  created(){			
		this.getData(this.$root.common.curorderid)
	  },
	  mounted(){
		document.title="服务产品详情"
	  },
	  methods:{
		getData(pn){
			var that = this
			let thisUrl = that.global.BASE_URL_T3 + '/api/web2/getProductbyProductCode?ProductCode=' + pn
			Vue.axios.get(thisUrl)
			   .then( function (response) {						  
				   that.orderList = response.data.Data[0];	
			   })			   
			   .catch(function (error) {
			    console.log(error);
			   }) 	
		}
	  }
	}
</script>

<style scoped>
.product-detail-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding-bottom: 80px;
}

.product-image-section {
    background-color: #ffffff;
    padding: 30px 20px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
}

.product-image {
    width: 200px;
    height: 200px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.info-card {
    background-color: #ffffff;
    margin: 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    overflow: hidden;
}

.info-section,
.intro-section,
.price-section {
    padding: 20px;
    border-bottom: 1px solid #f5f5f5;
}

.info-section:last-child,
.intro-section:last-child,
.price-section:last-child {
    border-bottom: none;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 16px;
    text-align: left;
}

.info-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0;
}

.info-label {
    font-size: 14px;
    color: #646566;
    font-weight: 500;
    min-width: 80px;
}

.info-value {
    font-size: 14px;
    color: #323233;
    font-weight: 500;
    text-align: right;
    flex: 1;
    margin-left: 16px;
}

.name-value {
    color: #1989fa;
    font-weight: bold;
    line-height: 1.4;
}

.intro-content {
    background-color: #f8f9fa;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 16px;
    font-size: 14px;
    color: #323233;
    line-height: 1.6;
    text-align: left;
}

.price-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: linear-gradient(135deg, #fff2f0, #fff);
    border: 1px solid #ffccc7;
    border-radius: 8px;
}

.price-label {
    font-size: 15px;
    color: #d46b08;
    font-weight: 500;
}

.price-value {
    font-size: 24px;
    font-weight: bold;
    color: #cf1322;
}

.action-section {
    padding: 16px;
    background-color: #ffffff;
    border-top: 1px solid #f0f0f0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}

.back-btn {
    border-radius: 8px;
}

.btn-icon {
    margin-right: 4px;
}
</style>